<template>
  <b-card no-body class="monitoring-card">
    <b-card-header class="monitoring-header">
      <div class="header-title">
        <i class="fas fa-eye mr-2"></i>
        <strong>Acompanhamento Externo</strong>
      </div>
      <div class="header-actions">
        <b-button
          v-if="canEdit"
          :disabled="loadingMonitorings"
          variant="primary"
          size="sm"
          @click="$emit('open')"
          >Inserir
        </b-button>
        <b-button
          v-if="canEdit"
          :disabled="loadingMonitorings"
          variant="secondary"
          size="sm"
          @click="$emit('toggle-response')"
        >
          <template v-if="complaint.monitoringResponseEnabled">
            Desabilitar Resposta
          </template>
          <template v-else> Habilitar Resposta </template>
        </b-button>
      </div>
    </b-card-header>
    <b-card
      v-for="monitoring in monitorings"
      :key="monitoring._id"
      :class="{ 'text-secondary': monitoring.hidden }"
    >
      <p class="card-text">
        <b-row>
          <b-col>
            <i class="fa fa-calendar-alt" aria-hidden="true" />
            {{ monitoring.createdAt | datetime }}
          </b-col>
          <b-col v-if="monitoring.type !== MonitoringType.RESPONSE" cols="*">
            <b-button
              v-if="canEdit"
              size="sm"
              variant="link"
              class="text-dark"
              :title="monitoring.hidden ? 'Exibir' : 'Ocultar'"
              @click="$emit('toggle-visibility', monitoring)"
            >
              <i
                class="fa"
                :class="{
                  'fa-eye': !monitoring.hidden,
                  'fa-eye-slash': monitoring.hidden,
                }"
                aria-hidden="true"
              />
            </b-button>
          </b-col>
        </b-row>
        <template v-if="monitoring.type !== MonitoringType.RESPONSE">
          <template v-if="companyUsers[monitoring.user]">
            <i class="fa fa-user" aria-hidden="true"></i>
            {{ companyUsers[monitoring.user].name }}
            {{ companyUsers[monitoring.user].surname }}
          </template>
          <template v-else-if="managedByCompanyUsers[monitoring.user]">
            <i class="fa fa-user-tie" aria-hidden="true"></i>
            {{ managedByCompanyUsers[monitoring.user].name }}
            {{ managedByCompanyUsers[monitoring.user].surname }}
          </template>
          <template v-else>
            <i class="fa fa-user-tie text-info" aria-hidden="true"></i>
            {{ conformitaUsers[monitoring.user].name }}
            {{ conformitaUsers[monitoring.user].surname }}
          </template>
        </template>
      </p>
      <p v-if="monitoring.type === MonitoringType.COMPANY" class="card-text">
        {{ monitoring.description }}
      </p>
      <p
        v-else-if="monitoring.type === MonitoringType.RESPONSE"
        class="card-text text-info"
      >
        <i class="fas fa-reply" aria-hidden="true" />
        {{ monitoring.response.text }}
      </p>
    </b-card>
  </b-card>
</template>

<script>
import MonitoringType from "../../../../../backend/models/MonitoringType.ts";

export default {
  name: "MonitoringCard",
  props: {
    complaint: { type: Object, required: true },
    canEdit: { type: Boolean, default: false },
    loadingMonitorings: { type: Boolean, default: false },
    monitorings: { type: Array, default: () => [] },
    companyUsers: { type: Object, default: () => ({}) },
    managedByCompanyUsers: { type: Object, default: () => ({}) },
    conformitaUsers: { type: Object, default: () => ({}) },
  },
  data() {
    return { MonitoringType };
  },
};
</script>

<style></style>
